<div class="space-y-4">
    <!-- Filters Header -->
    <div class="flex flex-col md:flex-row gap-4 justify-between items-center mb-6">
        <div class="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            <!-- Search -->
            <p-iconfield>
                <p-inputicon class="pi pi-search" />
                <input 
                    type="text" 
                    pInputText 
                    [(ngModel)]="searchText" 
                    (input)="onSearch()" 
                    [placeholder]="'professionals_search' | translate" 
                    class="w-full md:w-80" />
            </p-iconfield>

            <!-- Date range -->
            <div class="flex items-center gap-2 w-full md:w-auto">
                <p-datepicker 
                    [(ngModel)]="startDate" 
                    (onSelect)="onDateChange()"
                    [placeholder]="'professionals_date_start' | translate"
                    [showIcon]="true"
                    styleClass="w-full md:w-40"
                    [inputStyle]="{'width':'100%'}"
                    class="flex-1">
                </p-datepicker>
                <span class="text-slate-400 shrink-0">{{ 'to' | translate }}</span>
                <p-datepicker 
                    [(ngModel)]="endDate" 
                    (onSelect)="onDateChange()"
                    [placeholder]="'professionals_date_end' | translate"
                    [showIcon]="true"
                    styleClass="w-full md:w-40"
                    [inputStyle]="{'width':'100%'}"
                    class="flex-1">
                </p-datepicker>
            </div>
        </div>

        <div class="flex items-center gap-3">
            <app-button 
                *ngIf="searchText || startDate || endDate" 
                [label]="'CLEAR_FILTERS' | translate" 
                (onClick)="clearFilters()" 
                variant="secondary">
            </app-button>

            <app-button *hasPermission="'Profissionais:create'"
                styleClass="!p-2 !w-10 !h-10 !rounded-full border-none flex items-center justify-center transition-colors duration-200"
                variant="primary"
                icon="pi pi-lock"
                [pTooltip]="'professionals_block_schedule' | translate"
                tooltipPosition="bottom"
                (onClick)="openBlockSchedule()">
            </app-button>
        </div>
    </div>

    <!-- Main Table Section -->
    <div class="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-sm h-[600px]">
        <app-prime-table
            [columns]="cols"
            [data]="blockedProfessionals"
            [loading]="loading"
            [totalRecords]="totalRecords"
            [rows]="pageSize"
            [lazy]="true"
            (onPage)="onPageChange($event)"
            [templates]="templates"
            scrollHeight="flex"
            [scrollable]="true"
            [paginator]="true">
        </app-prime-table>
    </div>

    <!-- Templates -->
    <ng-template #doctor_name let-row>
        <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-full overflow-hidden bg-slate-100 flex-shrink-0">
                <img 
                    [src]="row.photo || 'assets/images/user-profile.png'" 
                    class="w-full h-full object-cover"
                    onerror="this.src='assets/images/user-profile.png'" />
            </div>
            <span class="font-medium text-slate-700">{{ row.doctor_name || '-' }}</span>
        </div>
    </ng-template>

    <ng-template #date_cell let-row let-col="col">
        <span class="text-slate-600">{{ formatDate(row[col.field]) }}</span>
    </ng-template>

    <ng-template #time_cell let-row let-col="col">
        <span class="text-slate-600">{{ formatTime(row[col.field]) }}</span>
    </ng-template>

    <ng-template #actions_cell let-row>
        <div class="flex justify-center">
            <app-button *hasPermission="'Profissionais:delete'"
                styleClass="!p-2 !w-8 !h-8 !rounded-full !bg-red-50 !text-red-500 hover:!bg-red-100 border-none flex items-center justify-center transition-colors duration-200"
                variant="secondary"
                icon="pi pi-trash"
                (onClick)="onDelete(row)">
            </app-button>
        </div>
    </ng-template>

    <p-confirmDialog 
        [style]="{width: '450px'}" 
        rejectButtonStyleClass="!text-slate-500 !font-medium"
        acceptButtonStyleClass="!bg-red-500 !border-red-500 !text-white !font-medium">
    </p-confirmDialog>
    <p-toast></p-toast>
</div>